export default "__VITE_ASSET__DJIft2Of__"